


interface bookingInfo {
  date: string;
  time:any [];
  court_id: 1 | 2 ;
  customerName: string;
  customerPhone: string;
  customerEmail: string;
  payment_method:  1 | 2 ;
}


const initBooking: bookingInfo = {
  time: [],
  date : "2022-10-16",
  court_id: 2,
  customerName: null,
  customerPhone: null,
  customerEmail:null,
  payment_method:2
};


export { bookingInfo, initBooking };
